import { render, staticRenderFns } from "./MainSidebar.vue?vue&type=template&id=347e9e3c&"
import script from "./MainSidebar.vue?vue&type=script&lang=ts&"
export * from "./MainSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./MainSidebar.vue?vue&type=style&index=0&id=347e9e3c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports